import { create } from "zustand";

interface CommentFormModalSlice {
    isOpen: boolean;
    setIsOpen: (value: boolean, mode?: CommentFormModeEnum) => void;
    setMode: (mode?: CommentFormModeEnum) => void;
    mode?: CommentFormModeEnum;
}

export const useCommentModalState = create<CommentFormModalSlice>()((set) => ({
    isOpen: false,
    mode: undefined,
    setIsOpen: (
        newValue: boolean,
        newMode: undefined | CommentFormModeEnum = undefined,
    ) => set(() => ({ isOpen: newValue, mode: newMode })),
    setMode: (mode = undefined) => set(() => ({ mode: mode })),
}));

export enum CommentFormModeEnum {
    DEFAULT = "default",
    TEXT = "text",
    LINKOUT = "linkout",
    IMAGES = "images",
}
